import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  NumeroContrato: Yup.string().matches(
    /^\d*$/,
    "El Número de Contrato solo debe contener números"
  )
});

export default validationSchema;
